import React from "react"
import { useTranslation } from "react-i18next"

import { WithClassName } from "shared/types/WithClassName"
import { User } from "shared/types/__generated__/graphql"
import { Readonly } from "shared/ui/readonly/Readonly"

export const ProjectFormLastChangedBy = React.memo(
  ({
    user,
    isLoading,
    className
  }: {
    user: Pick<User, "name" | "email">
    isLoading?: boolean
  } & WithClassName) => {
    const { t } = useTranslation()

    return (
      <Readonly.Root className={className} isLoading={isLoading}>
        <Readonly.Label>{t("General.LastChangedBy")}</Readonly.Label>
        <Readonly.Value>{user?.name || user?.email}</Readonly.Value>
      </Readonly.Root>
    )
  }
)

ProjectFormLastChangedBy.displayName = "ProjectFormLastChangedBy"
